import React, {useState} from "react";
import { Box, Button } from "@mui/material";
import { motion } from "framer-motion";
import { clearCurrentWorkout } from "../../redux/slices/workoutSlice";
import { useNavigate } from "react-router-dom";
import WeeklyStats from "./WeeklyStats";
import WorkoutStats from "./WorkoutStats"
import RecentWorkout from "./RecentWorkout";
import ExerciseList from "./ExerciseList";
import CreateWorkoutButton from "../shared/CreateWorkoutButton";
import { useDispatch, useSelector } from "react-redux";
import { Brain } from 'lucide-react';
import SocialMediaWorkoutModal from "../SocialMediaWorkout/SocialMediaWorkoutModal";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { workout_id } = useSelector((state) => state.workoutSlice)

  const [modalOpen, setModalOpen] = useState(false)

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }


  const handleStartWorkoutFlow = async () => {
    if (workout_id) {
      dispatch(clearCurrentWorkout())
    }
    navigate("/workout-type-select");
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none", // For Chrome, Edge, and Safari
        },
      }} // Prevent default scrollbar
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingTop: "12px",
            paddingRight: "16px",
            paddingBottom: "12px",
          }}
        >

          <CreateWorkoutButton size={60} onClick={handleStartWorkoutFlow} />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<Brain />}
            onClick={handleOpenModal}
            sx={{
              py: 1.5,
              px: 4,
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "1rem",
              borderRadius: '4px',
              marginTop: '4px',
              marginBottom: '8px'
            }}
          >Create Workout from Social Media</Button>
          <WeeklyStats />
          <RecentWorkout />
          <WorkoutStats />
          <ExerciseList />
          <SocialMediaWorkoutModal open={modalOpen} onClose={handleCloseModal}/>
        </Box>

      </Box>
    </motion.div>
  );
};

export default Home;
